'use-strict';

module.exports = function () {
    if ($('.sidebar-navigation').length > 0) {
        $('.sidebar-navigation a').each(function () {
            if (window.location.href === $(this).attr('href')) {
                $(this).addClass('active');
            }
        });

        $('body').on('click', '.sidebar-navigation-toggle', function () {
            $(this).parent().toggleClass('active');
            $(this).attr('aria-expanded', $(this).attr('aria-expanded') !== 'true');
        });
    }
};
